var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { OPTION_CLASS, ICON_BUTTON, FRAMES_BUTTON } from "./Classes";

var Icon = function Icon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000"
  }, props), React.createElement("path", {
    d: "M10 270.19V418h107.32l.41-93.75.61-93.55 93.75-.61 93.55-.41V122.36H10v147.83zM694.38 176.03v53.66h186.28V418H990V122.38H694.38v53.65zM10 729.81v147.81h295.62V770.3h-188.3V582H10v147.81zM880.66 676.16v94.15H694.38v107.32H990V582H880.66v94.16z"
  }));
};

var FramesButton = function (_React$Component) {
  _inherits(FramesButton, _React$Component);

  function FramesButton() {
    _classCallCheck(this, FramesButton);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  FramesButton.prototype.render = function render() {
    var _props = this.props,
        toggle = _props.toggle,
        toggled = _props.toggled;
    return React.createElement("div", {
      className: OPTION_CLASS + " " + FRAMES_BUTTON
    }, React.createElement("button", {
      className: "button " + ICON_BUTTON,
      onClick: toggle
    }, React.createElement(Icon, {
      height: "100%",
      fill: toggled ? "#12b2d9" : "#FFF"
    })));
  };

  return FramesButton;
}(React.Component);

FramesButton.propTypes = process.env.NODE_ENV !== "production" ? {
  toggled: PropTypes.bool,
  toggle: PropTypes.func.isRequired
} : {};
export default FramesButton;